import * as React from 'react';
import { FareFeaturePaymentType } from '@websky/graphql';

export const redwingsPaymentIcons = {
	[FareFeaturePaymentType.Free]: (
		<svg
			className="icon__free"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.9993 8.00002C13.9993 11.3137 11.3131 14 7.99935 14C4.68564 14 1.99935 11.3137 1.99935 8.00002C1.99935 4.68631 4.68564 2.00002 7.99935 2.00002C11.3131 2.00002 13.9993 4.68631 13.9993 8.00002ZM15.3327 8.00002C15.3327 12.0501 12.0494 15.3334 7.99935 15.3334C3.94926 15.3334 0.666016 12.0501 0.666016 8.00002C0.666016 3.94993 3.94926 0.666687 7.99935 0.666687C12.0494 0.666687 15.3327 3.94993 15.3327 8.00002ZM7.13741 11.0809L11.9421 6.27615L10.9993 5.33334L7.13741 9.19527L5.60881 7.66667L4.666 8.60948L7.13741 11.0809Z"
				fill="currentColor"
			/>
		</svg>
	),
	[FareFeaturePaymentType.Pay]: (
		<svg
			className={'icon__pay'}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 12C1 5.928 5.928 1 12 1C18.072 1 23 5.928 23 12C23 18.072 18.072 23 12 23C5.928 23 1 18.072 1 12ZM10.8939 16.9375H13.6375V15.125H10.8939V14.1696H13.5864C14.9724 14.1518 16.0545 13.7857 16.8327 13.0714C17.6109 12.3512 18 11.3601 18 10.0982C18 8.86012 17.591 7.86905 16.773 7.125C15.9551 6.375 14.8616 6 13.4926 6H8.74671V12.3571H7V14.1696H8.74671V15.125H7V16.9375H8.74671V19H10.8939V16.9375ZM13.4586 12.3571H10.8939V7.82143H13.5864C14.2907 7.83929 14.8417 8.05952 15.2393 8.48214C15.6427 8.90476 15.8443 9.4494 15.8443 10.1161C15.8443 10.8601 15.6398 11.4196 15.2308 11.7946C14.8218 12.1696 14.2311 12.3571 13.4586 12.3571Z"
				fill="currentColor"
			/>
		</svg>
	),
	[FareFeaturePaymentType.NotAvailable]: (
		<svg
			className={'icon__notAvailable'}
			width="20"
			height="18"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.3335 7.99992C13.3335 10.9454 10.9457 13.3333 8.00016 13.3333C6.83851 13.3333 5.7636 12.9619 4.88769 12.3313L12.3316 4.88745C12.9621 5.76336 13.3335 6.83827 13.3335 7.99992ZM3.91026 11.4232L11.4234 3.91002C10.4971 3.13388 9.30319 2.66659 8.00016 2.66659C5.05464 2.66659 2.66683 5.0544 2.66683 7.99992C2.66683 9.30295 3.13412 10.4968 3.91026 11.4232ZM14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z"
				fill="currentColor"
			/>
		</svg>
	)
};
